/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useRef, useEffect } from 'react';
import {
  Card,
  Form,
  Button,
  Modal,
  InputGroup,
  Row,
  Col,
} from 'react-bootstrap';
import { StorageModule } from '@vlinder-web/storage-module-react';
// import {
//   PencilIcon,
//   MailIcon,
//   PhoneIcon,
//   DocumentAddIcon,
//   WifiIcon,
// } from "@heroicons/react/solid";
import { ChoosePhotoWidget } from '@vlinder-web/choose-photo-widget-react';
import { TweetyWidget } from '@/widgets/tweety-widget-react-main';
import { OrganisationProfilePageService } from '../../services';
import { vappContainer } from '@/application';

const getSrv = () => {
  return vappContainer.get<OrganisationProfilePageService>(
    OrganisationProfilePageService.displayName
  );
};

export interface IEditGroupModel {
  showModal?: boolean;
  createModalLabel?: string;
  nameLabel?: string;
  newFields?: any;
  logoLabel?: string;
  emailLabel?: string;
  initialData?: any;
  fields?: any;
  layout?: any;
  validatorConfig?: any;
  dynamicLayout?: any;
  fileFields?: any;
  phoneNumberLabel?: string;
  addressLabel?: string;
  websiteLabel?: string;
  descriptionLabel?: string;
  submitButtonText?: string;
  signupButtonStyle?: any;
  defaultName?: string;
  defaultEmail?: string;
  defaultPhoneNumber?: string;
  defaultAddress?: string;
  defaultWebsite?: string;
  defaultDescription?: string;
  defaultProfileImg?: string;
  citydata?: any;
  parish?: any;
  whoami: String;
  onAcknowledgement?(
    name: string,
    description: string,
    email: string,
    phoneNumber: string,
    address: string,
    website: string,
    profileImg?: string
  ): void;
  onDeny?(): void;
}

export const EditProfileModal = ({
  showModal,
  initialData,
  fields,
  layout,
  validatorConfig,
  dynamicLayout,
  newFields,
  createModalLabel,
  nameLabel,
  logoLabel,
  emailLabel,
  phoneNumberLabel,
  websiteLabel,
  addressLabel,
  descriptionLabel,
  defaultAddress,
  defaultEmail,
  defaultWebsite,
  defaultName,
  defaultPhoneNumber,
  defaultDescription,
  submitButtonText,
  signupButtonStyle,
  whoami,
  onDeny,
  onAcknowledgement,
  defaultProfileImg,
}: IEditGroupModel) => {
  const storageService = StorageModule.getInstance();
  const _localData = storageService.get('myProfile', 'local');
  const _sessionData = storageService.get('myProfile', 'session');
  const userData = _sessionData ?? _localData;
  const [show, setShow] = useState(showModal);
  const [profileImg, setProfileImg] = useState<any>(null);
  const [data, setdata] = useState({});
  const nameRef = useRef(null);
  const contactRef = useRef(null);
  const addressRef = useRef(null);
  const websiteRef = useRef(null);
  const descriptionRef = useRef(null);
  const [formFields, setFormFields] = useState(fields);
  const [selectForm, setselectForm] = useState('new');
  const [sinitialData, setinitialData] = useState({
    ...initialData,
    ...userData?.org,
  });
  console.log('adddl', sinitialData);
  const [initdata, setInitdata] = useState({
    operatingaddressLine1: sinitialData?.operatingAddress?.addressLine1,
    operatingaddressLine2: sinitialData?.operatingAddress?.addressLine2,
    operatingParish: sinitialData?.operatingAddress?.parish,
    operatingCity: sinitialData?.operatingAddress?.city,
    primaryContactNo: sinitialData?.initialData?.primaryContactNo,
    operatingzipcode: sinitialData?.operatingAddress?.zipcode,
    isAddDirector: sinitialData?.isDirectorExist ? 'yes' : 'no',
    isAddSubsidiary: sinitialData?.isSubsidiaryExist ? 'yes' : 'no',
    isAddBranch: sinitialData?.isBranchExist ? 'yes' : 'no',
    directors: sinitialData?.initialData?.directors,
    subsidiaries: sinitialData?.initialData?.subsidiaries,
    branches: sinitialData?.initialData?.branches,
  });
  let ssinitdata = { ...initialData, ...userData?.org };
  const [slayout, setlayout] = useState([]);
  const handleClose = () => {
    if (onDeny) {
      onDeny();
    }
    setShow(false);
  };
  let directorsid = [];
  directorsid = sinitialData?.directors?.map((e: any, kkk: any) => {
    return { ...e, id: e.email };
  });
  // setinitialData({...sinitialData,directors:directorsid})
  console.log('userdata->>>', initialData, userData.org, directorsid);
  const _deletemanagerial = async (id: any, payload1: any) => {
    // let payload=payload1;
    if (id === 'subsidiaries' || id === 'branches' || id === 'directors') {
      // payload={}

      console.log(`response from subsiii111`, id, payload1);
      await getSrv().agent.createProfile({ [id]: [payload1], documents: [] });
      // const res=await getSrv().agent.createProfile({subsidiaries : [...payload1]});
      console.log(`response from subsiii222`, id, payload1, res);
    }
  };
  const _onChange = async (id: any, payload: any, bool?: any) => {
    if (bool === true)
      setinitialData({
        ...sinitialData,
        initialData: { ...sinitialData?.initialData, [id]: payload },
      });
    console.log(`response from parish :: 1`, id, payload, formFields);
    if (id !== 'dynamicField') setInitdata({ ...initdata, [id]: payload });

    if (id === 'dynamicField') {
      const _response = await getSrv().agent.getCities(payload?.payload);
      console.log(`response from parish ::`, _response);
      if (_response) {
        let _fields: any = formFields.map((item: any, index: number) => {
          if (item?.compProps?.id === payload?.id) {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                attributeForm: {
                  ...item?.compProps?.attributeForm,
                  fields: _getFormatedFields(
                    item?.compProps?.attributeForm?.fields,
                    payload?.subId,
                    _response
                  ),
                },
              },
            };
          } else {
            return { ...item };
          }
        });
        setFormFields(_fields);
      }
    }
    // if (
    //   id === 'dynamicField' &&
    //   (payload?.subId === 'parish' || payload?.subId === 'operatingParish')
    // ) {
    //   //onParishChange && onParishChange({ ...initialData, [id]: payload });
    //   const _response = await getSrv().agent.getCities(payload?.payload);
    //   console.log(`response from parish ::`, formFields);
    //   if (_response) {
    //     let _fields: any = formFields.map((item: any, index: number) => {
    //       console.log(payload?.subId, item?.compProps?.id);
    //       if (payload?.subId === 'parish' && item?.compProps?.id === 'city') {
    //         return {
    //           ...item,
    //           compProps: {
    //             ...item?.compProps,
    //             options: _response?.cities,
    //           },
    //         };
    //       } else if (
    //         payload?.subId === 'operatingParish' &&
    //         item?.compProps?.id === 'operatingCity'
    //       ) {
    //         return {
    //           ...item,
    //           compProps: {
    //             ...item?.compProps,
    //             options: _response?.cities,
    //           },
    //         };
    //       } else {
    //         return {
    //           ...item,
    //         };
    //       }
    //     });
    //     console.log(`response from parish ::`, formFields);
    //     setFormFields(_fields);
    //   }
    // }

    if (id === 'parish' || id === 'operatingParish') {
      //onParishChange && onParishChange({ ...initialData, [id]: payload });
      const _response = await getSrv().agent.getCities(payload);
      console.log(`response from parish ::`, _response);
      if (_response) {
        let _fields: any = formFields.map((item: any, index: number) => {
          if (id === 'parish' && item?.compProps?.id === 'city') {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else if (
            id === 'operatingParish' &&
            item?.compProps?.id === 'operatingCity'
          ) {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else {
            return {
              ...item,
            };
          }
        });

        setFormFields(_fields);
      }
    }
  };
  console.log('sinitialData2323', sinitialData, layout);
  const _getFormatedFields = (fieldz: any[], id: string, response: any) => {
    console.log('0007 inside function', fieldz, id, response);
    let _res: any[] = [];
    _res =
      fieldz &&
      Array.isArray(fieldz) &&
      fieldz.length > 0 &&
      fieldz.map((item: any, index: number) => {
        if (id === 'parish' && item?.compProps?.id === 'city') {
          return {
            ...item,
            compProps: {
              ...item?.compProps,
              options: response?.cities,
            },
          };
        } else {
          return { ...item };
        }
      });
    console.log(`response from parish :: #3 0007`, _res);
    return _res;
  };
  const _getDocument = (payload: any) => {
    console.log('paylooads', payload);
    const availDocuments = {
      businessRegistration: 'BUSSINESS_REGISTRATION',
      taxClearanceCertificate: 'TAX_CLEARANCE_CERTIFICATE',
      articleOfIncorporation: 'ARTICAL_OF_INCORPORATION',
      certificateOfIncorporation: 'CERTIFICATE_OF_INCORPORATION',
      annualReturn: 'ANNUAL_RETURN',
      immigrationStatus: 'IMMIGRATION_STATUS',
      certificateOfGoodStading: 'CERTIFICATE_OF_GOOD_STANDING',
      bankStatement: 'BANK_STATMENT',
      existingInvoices: 'EXISTING_INVOICES',
      leaseOrRentalAgreement: 'LEASE_AGREEMENT',
      companyReceipt: 'COMPAY_OFFICE_OF_JAMAICA_RECEIPT',
    };
    let _documents: any = {};
    availDocuments &&
      Object.entries(availDocuments).forEach((ele, index) => {
        let _similarDoc: any[] = [];
        payload &&
          Array.isArray(payload) &&
          payload.length > 0 &&
          payload.map((doc: any) => {
            if (doc?.type === ele[1]) {
              _similarDoc.push({
                name: doc?.name,
                src: doc?.src,
                type: doc?.fileType,
              });
            }
          });
        _documents[ele[0]] = _similarDoc;
      });
    console.log('formatAppDraft getDocuments ', _documents);
    console.log('paylooads2', _documents);
    return _documents;
  };
  useEffect(() => {
    console.log('USANDATA edit', userData);

    const documents = _getDocument(userData?.org?.documents);
    console.log('123213123', documents);
    if (userData?.email && whoami !== 'prospective_employee') {
      setinitialData({
        ...sinitialData,
        ...initialData,
        ...documents,
      });
    }

    if (
      sinitialData?.operatingAddress?.parish &&
      sinitialData?.operatingAddress?.city
    ) {
      _onChange(
        'operatingParish',
        sinitialData?.operatingAddress?.parish,
        false
      );
    }
  }, []);
  useEffect(() => {
    if (selectForm === 'new') {
      setFormFields([...fields, ...newFields]);
      setlayout([...layout]);
    } else if (selectForm === 'existing') {
      setlayout([...existingLayout]);
      let __fields =
        fields &&
        fields.map((_field: any) => {
          if (_field?.compProps?.id === 'website') {
            return {
              ..._field,
              compProps: {
                ..._field.compProps,
                required: true,
              },
            };
          } else return _field;
        });
      setFormFields([...__fields, ...existingFields]);
    }
  }, [selectForm]);

  const handlePhotoChosen = (file: any) => {
    setProfileImg(file?.base64);
  };

  const _renderSubmitButton = () => {
    return (
      <Row
        className="mt-3"
        style={{ justifyContent: 'space-around', display: 'flex' }}
      >
        <Col xs={12} md={5} lg={4}>
          <Button
            variant="secondary"
            type="submit"
            className="mt-2 animate-up-2"
            style={{
              borderRadius: '0px',
              height: '40px',
              fontWeight: 'bold',
            }}
          >
            Update
          </Button>
        </Col>
      </Row>
    );
  };

  const _onFormSubmit = (event: any) => {
    if (event) {
      event.preventDefault();
      if (onAcknowledgement) {
        onAcknowledgement(
          nameRef?.current?.value,
          descriptionRef?.current?.value,
          contactRef?.current?.value,
          addressRef?.current?.value,
          websiteRef?.current?.value,
          profileImg
        );
      }
      // 👇️ clear all input values in the form
      event.target.reset();
    }
    setShow(false);
  };

  console.log('sinitialData', sinitialData);

  return (
    <Modal centered show={show} onHide={handleClose} size={'lg'}>
      <Modal.Header className="border-0">
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body className="p-0">
        <Card border="light" className="px-0 px-md-4 py-0 border-0">
          <Card.Header className="text-center text-md-center border-0 mb-0 mt-md-0">
            <h4>Update Profile</h4>
          </Card.Header>
          <Card.Body>
            <TweetyWidget
              submitButtonLabel={'Update'}
              size={'lg'}
              labelColor={'#104382'}
              // key={`${activeStep}${selectForm}`}
              fields={formFields}
              // initialData={{
              //   ...sinitialData?.initialData,
              //   directors: directorsid,
              //   // isAddDirector:
              //   // sinitialData?.initialData?.directors?.length > 0
              //   //     ? 'yes'
              //   //     : 'no',
              // }}
              initialData={initdata}
              // initialData={sinitialData?.initialData}
              layout={layout}
              onChange={(id, payload) => {
                console.log(`onChange in index: `, id, payload);
                _onChange(id, payload, id === 'parish' ? true : false);
              }}
              _deletemanagerial={_deletemanagerial}
              dynamicLayout={dynamicLayout}
              onFormSubmit={(payload: any) => {
                console.log('find->updateProfile', payload);
                onAcknowledgement && onAcknowledgement({ ...payload });
              }}
              renderSubmitButton={_renderSubmitButton}
              validatorConfig={validatorConfig}
            />
            {/* <FileComp  formFields={staticPageContentConfig?.formData?.fileFields} /> */}
          </Card.Body>
        </Card>
      </Modal.Body>
    </Modal>
  );
};

EditProfileModal.defaultProps = {
  showModal: false,
  createModalLabel: 'Edit Profile',
  nameLabel: 'Full Name',
  // descriptionLabel: "Description",
  emailLabel: 'Email Address',
  phoneNumberLabel: 'Contact No.',
  // addressLabel: "Address",
  // websiteLabel: "Website",
  submitButtonText: 'Update Profile',
  logoLabel: 'Profile Image',
};
